export default __webpack_public_path__ + "static/media/Astro_Trine_White.7058b165.png";